import markdownit from "markdown-it";

export function markdownToHtml(markdown: string) {
  const md = markdownit({ breaks: true });
  const oldNormalizeLink = md.normalizeLink;
  md.normalizeLink = (url: string) => (url.includes("{") && url.includes("}") ? url : oldNormalizeLink(url));

  return md.render(markdown);
}
